//General
import React, { useContext } from "react";
//Styles
import { Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { TextField, Autocomplete } from "@mui/material";
//Context 
import { VehiclesContext } from "../../data/vehicles/VehiclesContext";
import { useValidations } from "../../data/ValidationContext";
import { DealersContext } from "../../data/dealers/DealersContex";

const VehiclesAddModal = ({ isOpen, onClose }) => {
    const { vehiclesList, addVehicle } = useContext(VehiclesContext);
    const { dealersList } = useContext(DealersContext);
    const { vs_vehicle } = useValidations();

    const initialValues = { brand: "", model: "", plate: "", description: "", dealerName: "" };
    
    //HTML

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Formik
                initialValues={initialValues}
                validationSchema={vs_vehicle}
                onSubmit={(values) => {
                    const isDuplicate = vehiclesList.some(
                        (v) => v.plate.toLowerCase() === values.plate.toLowerCase()
                    );
                    if (isDuplicate) {
                        alert("Bu plaka zaten kayıtlı!");
                        return;
                    }
                    addVehicle(values);
                    onClose();
                }}
            >
                {({ values, errors, touched, handleChange, setFieldValue }) => (
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>Araç Ekle</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className="row mb-3">
                                <div className="col">
                                    <TextField
                                        label="Marka"
                                        name="brand"
                                        value={values.brand}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                        error={touched.brand && !!errors.brand}
                                        helperText={touched.brand && errors.brand}
                                    />
                                </div>
                                <div className="col">
                                    <TextField
                                        label="Model"
                                        name="model"
                                        value={values.model}
                                        onChange={handleChange}
                                        fullWidth
                                        size="small"
                                        error={touched.model && !!errors.model}
                                        helperText={touched.model && errors.model}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <TextField
                                    label="Plaka"
                                    name="plate"
                                    value={values.plate}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    error={touched.plate && !!errors.plate}
                                    helperText={touched.plate && errors.plate}
                                />
                            </div>

                            <div className="mb-3">
                                <Autocomplete
                                    options={dealersList.map((d) => d.name)}
                                    value={values.dealerName || null}
                                    onChange={(_, newValue) => setFieldValue("dealerName", newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Bayi"
                                            size="small"
                                            error={touched.dealerName && !!errors.dealerName}
                                            helperText={touched.dealerName && errors.dealerName}
                                        />
                                    )}
                                />
                            </div>

                            <div>
                                <TextField
                                    label="Açıklama"
                                    name="description"
                                    value={values.description}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    multiline
                                    minRows={2}
                                    error={touched.description && !!errors.description}
                                    helperText={touched.description && errors.description}
                                />
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                İptal
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Kaydet
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default VehiclesAddModal;
